import React from 'react';
import { useReactToPrint } from 'react-to-print';
type Props = {
  customerContent: () => React.ReactInstance | null;
  staffContent: () => React.ReactInstance | null;
  ownerContent: () => React.ReactInstance | null;
  customPrintStaffReceipt?: () => void;
};
const usePrintReceiptWithStaff = ({ customerContent, staffContent, customPrintStaffReceipt }: Props) => {

  const doPrintStaffReceipt = customPrintStaffReceipt || useReactToPrint({
    content: () => staffContent(),
  });

  const doPrint = useReactToPrint({
    content: () => customerContent(),
    onAfterPrint: () => doPrintStaffReceipt(),
  });


  return doPrint;
};

export default usePrintReceiptWithStaff;
